export const POLYGON_ACTIVE = 'POLYGON_ACTIVE';
export const POLYGON_HIGHLIGHTED = 'POLYGON_HIGHLIGHTED';
export const POLYGON_SOLID = 'POLYGON_SOLID';
export const POLYGON_THIN = 'POLYGON_THIN';
export const POLYGON_DEFAULT = 'POLYGON_DEFAULT';
